import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import ICU from 'i18next-icu';
import { he } from '../locales/he';
import { en } from '../locales/en';

// Only init once (safe for Next.js which may import this module multiple times)
if (!i18next.isInitialized) {
  void i18next
    .use(ICU)
    .use(initReactI18next)
    .init({
      lng: 'he',
      fallbackLng: 'en',
      resources: {
        he: { translation: he },
        en: { translation: en },
      },
      interpolation: { escapeValue: false },
    });
}

export { i18next };
